import { Coordinate } from "@nova/protobuf"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { selectFireById } from "features/entity-caching/fires/selectors"
import { SocketStore } from "../sockets/types"

export const centroid = (points: Coordinate[] | undefined | null) => {
    if (!points?.length) return null
    const sum = points.reduce(
        (s, p) => ({ longitude: s.longitude + p.longitude, latitude: s.latitude + p.latitude }),
        { longitude: 0, latitude: 0 }
    )
    return { longitude: sum.longitude / points.length, latitude: sum.latitude / points.length }
}

export const maybeSetProjectLocation = (
    store: SocketStore,
    orgId: string,
    projectId: string,
    location: Coordinate | null
) => {
    if (!location) return
    const project = selectFireById(projectId)(store.getState())
    if (!project || project.location) return

    fetchApiGateway("patch /org/:orgId/project/:projectId/location", {
        params: { orgId, projectId },
        body: { location },
    }).catch(console.error)
}
